// extracted by mini-css-extract-plugin
export default {"switchContainer":"ServiceLinesAdminTable_switchContainer__xy0xK","rowContainer":"ServiceLinesAdminTable_rowContainer__N93j4"};